/* eslint-disable max-len */
/* eslint-disable dot-notation */
import { Observable } from 'rxjs';
import { Action } from 'redux-actions';
import api from '@src/api';

export const getPersonalPayrollList = (): Observable<Action> => (
	api.get('payroll-tasks/front-desk')
);

export const getPersonalPayrollDetail = (payload: { id: string }): Observable<Action> => (
	api.get(`payroll-tasks/${payload.id}/front-desk`)
);
